module.exports = __webpack_public_path__ + "assets/img/report-suc.5af0f635.gif";